import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ReportService from '../../../services/reports';
import { normalizeReportParams } from '../../../helpers/reportQuery';
import { normalizeProductsReportFullPayload } from '../../../helpers/normalizeProductsReportResponse';

const initialState = {
  loading: false,
  topLines: [],
  categoryBreakdown: [],
  productList: { data: [], total: 0, per_page: 10, current_page: 1 },
  error: '',
};

/** Single request: topLines + categoryBreakdown + table (see ANALYTICS_REPORTS_FRONTEND_INTEGRATION.md). */
export const fetchProductsReportFull = createAsyncThunk(
  'report/fetchProductsReportFull',
  (params = {}) =>
    ReportService.getProductsReport(
      normalizeReportParams({ ...params, view: 'full', format: 'json' })
    )
);

const orderCountSlice = createSlice({
  name: 'productReport',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchProductsReportFull.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchProductsReportFull.fulfilled, (state, action) => {
      state.loading = false;
      const norm = normalizeProductsReportFullPayload(action.payload);
      state.topLines = norm.topLines;
      state.categoryBreakdown = norm.categoryBreakdown;
      state.productList = norm.productList;
      state.error = '';
    });
    builder.addCase(fetchProductsReportFull.rejected, (state, action) => {
      state.loading = false;
      state.topLines = [];
      state.categoryBreakdown = [];
      state.productList = initialState.productList;
      state.error = action.error.message;
    });
  },

  reducers: {
    filterReportProduct() {},
  },
});
export const { filterReportProduct } = orderCountSlice.actions;
export default orderCountSlice.reducer;
